// extracted by css-extract-rspack-plugin
export default {"root":"root-gS7Hdw text-xl-bold"};